/**
 * @fileoverview Handles the menu bar at the top of the application.
 */

import { elt } from './dom';
import type { SlMenuItem } from '@shoelace-style/shoelace';

function noOp(e: Event): void {
  e.preventDefault();
}

function menuTrigger(...body: any[]): HTMLAnchorElement {
  const el = elt('a', {
    class: 'rebuild-menu-item',
    href: '#',
    slot: 'trigger'
  }, ...body) as HTMLAnchorElement;

  el.addEventListener('click', noOp);

  return el;
}

function menuItem(...body: any[]): SlMenuItem {
  const el = elt('sl-menu-item', {}, ...body) as SlMenuItem;
  return el;
}

class GroovMenu extends HTMLElement {
  connectedCallback() {
    this.style.display = 'contents';

    const trigger = menuTrigger(elt('i', {}, 'groov'), ' View');
    const menu = elt('sl-menu', {},
      menuItem('About ', elt('i', {}, 'groov'), ' View')
    );

    const dropdown = elt('sl-dropdown', {}, trigger, menu);
    this.append(dropdown);
  }
}

class FileMenu extends HTMLElement {
  connectedCallback() {
    this.style.display = 'contents';

    const trigger = menuTrigger('File');
    const menu = elt('sl-menu', {},
      menuItem('Save All Changes'),
      menuItem('Save All Changes and Switch to ', elt('i', {}, 'groov'), ' View'),
      elt('sl-divider'),
      menuItem('Switch to ', elt('i', {}, 'groov'), ' View'),
      menuItem('Open ', elt('i', {}, 'groov'), ' View in New Tab'),
      elt('sl-divider'),
      menuItem('Import Page'),
      menuItem('Export Page'),
      elt('sl-divider'),
      menuItem('Backup Project to Computer'),
      menuItem('Restore Project from Backup'),
      menuItem('Reset Project')
    );

    const dropdown = elt('sl-dropdown', {}, trigger, menu);
    this.append(dropdown);
  }
}

function registerMenus() {
  customElements.define('rebuild-groov-menu', GroovMenu);
  customElements.define('rebuild-file-menu', FileMenu);
}

export class RebuildMenu extends HTMLElement {
  groovMenu: GroovMenu;
  fileMenu: FileMenu;

  connectedCallback() {
    registerMenus();

    this.groovMenu = elt('rebuild-groov-menu');
    this.fileMenu = elt('rebuild-file-menu');

    this.append(
      this.groovMenu,
      this.fileMenu
    );
  }
}
